export default {
  error_messages: {
    orders_disabled: 'Commande ici actuellement impossible',
  },
};
